document.addEventListener('DOMContentLoaded', ()=>{

  if ( document?.querySelectorAll('[js-initiate-cart]').length > 0 ){
    document?.querySelectorAll('[js-initiate-cart]').forEach((el)=>{
      el.addEventListener('click', (target)=>{
        target.preventDefault();
        const submitBtnInitiate = target.target.closest('.curatedProductGrid__item__media_ctabutton').querySelector('.product-form__submit[name="add"]');
        submitBtnInitiate.classList.add('loading');
        submitBtnInitiate.disabled = true;
        const cartDrawer = document.querySelector('cart-drawer');
        const itemInitaite = { id: target.target.closest('.curatedProductGrid__item__media_ctabutton').querySelector('[name="id"]').value, quantity: 1, }
        if (cartDrawer) cartDrawer.enableLoading();
        const bundleCart = {
          items: [itemInitaite],
          sections: cartDrawer?.getSectionsToRender()?.map(s => s.section) || [],
          sections_url: window.location.pathname
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(bundleCart),
          credentials: 'same-origin'
        }).then(res => res.json())
          .then(data => cartDrawer?.renderContent(data.sections))
          .catch(console.error)
          .finally(() => {
            if (cartDrawer) {
              cartDrawer.disableLoading();
              cartDrawer.open();
            }
            submitBtnInitiate.classList.remove('loading');
            submitBtnInitiate.disabled = false;
            if( document.querySelectorAll('.open__drawerLink').length > 0 ){
              document.querySelectorAll('.open__drawerLink').forEach((el)=>{el.classList.remove('active') });
            }
          });        

      })
    })
  }

  function setupMarquee({ contentId, containerSelector, speed = 0.5 }) {
    const scrollingContent = document.getElementById(contentId);
    if (!scrollingContent) {
      console.warn(`Marquee setup failed: Element with ID "${contentId}" not found.`);
      return;
    }
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Marquee setup failed: Container with selector "${containerSelector}" not found.`);
      return;
    }
    scrollingContent.innerHTML += scrollingContent.innerHTML;
    let x = 0;
    let isPaused = false;
    function animate() {
      if (!isPaused) {
        x -= speed;
        if (Math.abs(x) >= scrollingContent.scrollWidth / 2) {
          x = 0;
        }
        scrollingContent.style.transform = `translateX(${x}px)`;
      }
      requestAnimationFrame(animate);
    }
    container.addEventListener("mouseenter", () => { isPaused = true; });
    container.addEventListener("mouseleave", () => { isPaused = false; });
    animate();
  }
  setupMarquee({ contentId: "scrollingContent", containerSelector: ".squeeze_scroller_main", speed: 0.5 });

  if( document.querySelectorAll('.curatedbanner__holidayTimerMn').length > 0 ){

    function convertDateForCountdown(mmddyyyyString) {
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun", 
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const parts = mmddyyyyString.split('/');
        if (parts.length !== 3) {
            return null; 
        }
        const monthIndex = parseInt(parts[0], 10) - 1; 
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        const monthAbbreviation = monthNames[monthIndex];
        return `${monthAbbreviation} ${day}, ${year} 00:00:00`;
    }
    const FutureInputDate = document.querySelector(`[data-timer-control]`).dataset.timerControl;
    const formattedDate = convertDateForCountdown(FutureInputDate);

    function setupCountdown(targetDateString, elementId) {
        const countDownDate = new Date(targetDateString).getTime();
        const countdownElement = document.querySelector(elementId);
        const x = setInterval(function() {
            const now = new Date().getTime();
            const distance = countDownDate - now;
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            countdownElement.querySelector('[js-days-calculate]').innerHTML = `${days}`;
            countdownElement.querySelector('[js-hours-calculate]').innerHTML = `${hours}`;
            countdownElement.querySelector('[js-minutes-calculate]').innerHTML = `${minutes}`;
            countdownElement.querySelector('[js-seconds-calculate]').innerHTML = `${seconds}`;
            if (distance < 0) {
                clearInterval(x);
                countdownElement.classList.add('hidden');
            }
        }, 1000);
    }
    const endDate = formattedDate; 
    setupCountdown(endDate, ".curatedbanner__holidayTimerMn");
  }
})